import configuration from "../config";
import axios from "./axiosConfiguration";

const endpoint = `${configuration.api_url}battle`;

export const getBattles = () => {
    return axios
        .get(endpoint)
        .then((response) => {
            return Promise.resolve(response.data);
        })
        .catch((error) => {
            return Promise.reject(error);
        });
};

export const saveBattle = async (data) => {
    return axios
        .post(`${endpoint}`, data)
        .then((response) => {
            return Promise.resolve(response.data);
        })
        .catch((error) => {
            return Promise.reject(error);
        });
};

export const deleteBattle = async (blocId) => {
    return axios
        .delete(`${endpoint}/${blocId}`)
        .then((response) => {
            return Promise.resolve(response.data);
        })
        .catch((error) => {
            return Promise.reject(error);
        });
};
